import Statistics from "../../../model/statistics/Statistics";
import Page from "../../framework/Page";
import ParentView from "../../framework/ParentView";
import StatisticsView from "./StatisticsView";

export default class StatisticsContainerView extends ParentView {
    /**
     * @param {string} parentId
     * @param {Statistics} runStatistics
     * @param {Statistics} globalStatistics
     */
    constructor(parentId, runStatistics, globalStatistics) {
        super(parentId, parentId + '_container');

        const id = this.getElementId();
        this.addView(new StatisticsView(id, id + '_run', runStatistics, 'Current Run Statistics'));
        this.addView(new StatisticsView(id, id + '_global', globalStatistics, 'Cumulative Statistics'));
    }

    /**
     * Invoked at startup or after a save has been loaded.
     * @override
     */
    initializeView() {

        // <div id="statisticsPopup" class="popup-window-statistics" style="display: none;">

        const parentElement = Page.getElement(this.parentId);
        Page.createElement('div', parentElement, this.getElementId(), 'stats-container');

        this.setInitialVisibility(true);
        
        super.initializeView();
    }

    /**
     * @override
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'grid';
    }
}